import { Controller } from '@hotwired/stimulus'
import { delay, elementVisible } from '../utilities'

export default class extends Controller {
  static targets = ['emailInput', 'email', 'emailState']
  static values = { emails: { type: Array } }

  connect() {
    this.initialized = false
    this.initAnimation()
  }

  async initAnimation() {
    if (!elementVisible(this.element, 200) || this.initialized) return

    this.initialized = true
    await delay(500)
    this.emailInputTarget.dataset.focused = true

    let Typed

    try {
      Typed = (await import('typed.js')).default
    } catch (error) {
      console.error('Failed to load typed.js:', error)
      return
    }

    this.typist = new Typed(this.emailTarget, {
      backDelay: 3000,
      backSpeed: 30,
      startDelay: 1000,
      strings: this.emailsValue,
      typeSpeed: 40,
      onStringTyped: async (index, _self) => {
        await delay(250)
        this.emailStateTarget.classList.remove('opacity-0')

        if (index === this.emailsValue.length - 1) {
          this.emailStateTarget.dataset.state = 'deliverable'
        } else {
          await delay(2750)
          this.emailStateTarget.classList.add('opacity-0')
        }
      }
    })
  }
}
